import classnames from 'classnames';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import TabGroup from 'components/tab_group';
import TabHeader from 'components/tab_header';
import TabHeaders from 'components/tab_headers';
import TabPanel from 'components/tab_panel';
import TabPanels from 'components/tab_panels';
import Notifications from 'lib/manage/notifications';

import SubscriberCounts from './subscriber_counts';
import NotificationsSubscriberTypeManager from './notifications_subscriber_type_manager';


/**
 *  The interface to browse and search lists of email, sms, and web subscribers.
 */
export default class NotificationsSubscriberManager extends Component {
  static propTypes = {
    pageCode: PropTypes.string.isRequired, // The code of the page whose subscribers to list.
    limit: PropTypes.number.isRequired,
    enabledNotificationTypes: PropTypes.shape({
      email: PropTypes.bool.isRequired,
      sms: PropTypes.bool.isRequired,
      webhook: PropTypes.bool.isRequired,
    }).isRequired,
    requiresAdvancedNotifications: PropTypes.shape({
      email: PropTypes.bool.isRequired,
      sms: PropTypes.bool.isRequired,
      webhook: PropTypes.bool.isRequired,
    }).isRequired,
  };

  state = {
    updatedAt: moment().format(),
  };

  _touch = () => {
    this.setState({ updatedAt: moment().format() });
  }

  render () {
    const beginningOfPastMonthTimestamp = moment().subtract(1, 'month').startOf('day').format();
    return (
      // These components wrap network requests, allowing us to leverage the prop system to only make network requests when the parameters change
      <SubscriberCounts pageCode={this.props.pageCode} updatedAt={this.state.updatedAt}>
        {allTimeHistogram => (

          // Note that in spite of this being nested, its network request is independent of the results of the outer SubscriberCounts call.
          <SubscriberCounts
            pageCode={this.props.pageCode}
            since={beginningOfPastMonthTimestamp}
            updatedAt={this.state.updatedAt}>
            {thisMonthHistogram => (

              <TabGroup default="email"
                        onChange={deliveryType => analytics.track('Notifications Page - Clicked Tab', { deliveryType, source: 'Notifications Page' })}>
                <TabHeaders>
                  {
                    Notifications.NOTIFICATION_TYPES.map((type) => {
                      const countText = allTimeHistogram[type] ? ` (${allTimeHistogram[type].total})` : '';
                      const label = `${Notifications.SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE[type]}${countText}`;
                      return (
                        <TabHeader key={type} name={type} className={classnames(this.props.enabledNotificationTypes[type] ? null : 'disabled')}>
                          {label}
                        </TabHeader>
                      );
                    })
                  }
                </TabHeaders>
                <TabPanels>
                  {
                    Notifications.NOTIFICATION_TYPES.map((type) => {
                      const enabled = this.props.enabledNotificationTypes[type];
                      const requiresAdvancedNotifications = this.props.requiresAdvancedNotifications[type];
                      const displayUpgradeForNotificationTypeMessage = !enabled && requiresAdvancedNotifications;
                      const typeTitle = Notifications.SUBSCRIBER_TITLE_DISPLAY_TYPE_BY_TYPE[type];
                      const typeNoun = Notifications.SUBSCRIBER_SENTENCE_DISPLAY_TYPE_BY_TYPE[type];
                      const settingsModalLink = (
                        <a
                          href="#modal-settings"
                          data-toggle="modal"
                          onClick={() => analytics.track('Notifications Page - Settings Modal Clicked', { source: 'Notifications Page'})}>
                          reactivate {typeNoun} notifications now
                      </a>);
                      let disabledAlertBox = null;
                      if (displayUpgradeForNotificationTypeMessage) {
                        disabledAlertBox = (
                          <div className="disable-notification-type-warning">
                            <div className="header">{typeTitle} notifications are not available for your plan.</div>
                            <div className="body">To deliver notification through {typeNoun}, upgrade your plan.</div>
                          </div>
                        );
                      } else if (!enabled) {
                        disabledAlertBox = (
                          <div className="disable-notification-type-warning">
                            <div className="header">{typeTitle} notifications are disabled.</div>
                            <div className="body">To deliver notification through {typeNoun}, {settingsModalLink}.</div>
                          </div>
                        );
                      }
                      return (
                        <TabPanel for={type} key={type}>
                          {disabledAlertBox}
                          <NotificationsSubscriberTypeManager
                            allTimeHistogram={allTimeHistogram}
                            thisMonthHistogram={thisMonthHistogram}
                            pageCode={this.props.pageCode}
                            limit={this.props.limit}
                            type={type}
                            updatedAt={this.state.updatedAt}
                            touch={this._touch} />
                        </TabPanel>
                      );
                    })
                  }
                </TabPanels>
              </TabGroup>
            )}
          </SubscriberCounts>
        )}
      </SubscriberCounts>
    );
  }
}

module.exports = NotificationsSubscriberManager;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/notifications/notifications_subscriber_manager.jsx